module.exports = require('./lib/gauss');


//////////////////
// WEBPACK FOOTER
// ../retabulate-graphql/~/gauss/index.js
// module id = 323
// module chunks = 0